import React, { useState, useEffect, useRef } from 'react';
import {
    CheckboxStyled,
    MediumStyled,
    CheckboxSquareStyled,
} from './style.js';

const Checkbox = ({ name, filterSave, removeAllChoice, removeChoice, _showSearchingResults }) => {
    const [checked, setChecked] = useState(filterSave ? true : false);

    const _isCheckboxChecked = () => {
        _showSearchingResults(!checked);
        setChecked((prev) => !prev);
    };

    // componentDidUpdate: эффект без списка зависимостей, первый рендер пропускаем
    const prevProps = useRef(null);
    useEffect(() => {
        const prev = prevProps.current;
        prevProps.current = { removeAllChoice, removeChoice };

        if (!prev) return;

        // снять все выборы
        if (removeAllChoice !== prev.removeAllChoice) {
            setChecked(false);
        }
        // при клике на тег снимается выбор селекта
        if ((removeChoice !== prev.removeChoice) && removeChoice === "0") {
            setChecked(false);
        }
    }, [removeAllChoice, removeChoice]);

    return (
        <CheckboxStyled onClick={() => _isCheckboxChecked()}>
            <MediumStyled>
                {name}
            </MediumStyled>
            <CheckboxSquareStyled checked={checked}>
                <svg width="18" height="18" viewBox="0 0 18 18">
                    <path d="M16 2V16H2V2H16ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0Z" />
                    {checked && <path d="M6.00003 12.1698L1.83003 8.99984L0.410034 10.40984L6.00003 15.9998L18 3.99984L16.59 2.589844L6.00003 13.1698Z" />}
                </svg>
            </CheckboxSquareStyled>
        </CheckboxStyled>
    )
};

export default Checkbox;
